module.exports = __webpack_public_path__ + "static/media/languages.be5393c7.png";